export default class Abstract {
  constructor (item) {
    if (item instanceof Object === false) {
      throw new Error('You need to pass an Object to the constructor')
    }

    this.item = item
  }

  get id () {
    return this.item.id
  }

  get sectionTitle () {
    return this.item.properties.sectionTitle
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/abstract.js